<template>
  <div class="remaining-leave-content">
    <!--Header-->
    <div class="header-content">
      <p>{{ (listRetirement.length != 0) ? 'Retirement Information' : 'Remaining Leave Balance' }}</p>
    </div>

    <div v-if="showFilter" class="action-content">
      <div class="action-search">
        <input type="text" v-model="searchQuery" placeholder="Search">
        <Icon :path="mdiMagnify" :w="'w-6'" :h="'h-6'" class="search-icon" />
      </div>

      <div class="action-sort" @click="toggleSort">
        <Icon v-if="sortOrder == 'desc'" :path="mdiSort" :w="'w-6'" :h="'h-6'" class="sort-icon" />

        <p v-if="sortOrder == ''" class="sort-icon">A-Z</p>

        <p v-if="sortOrder == 'asc'" class="sort-icon">Z-A</p>
      </div>
    </div>

    <div v-if="!isLoading && (listRetirement.length != 0)" class="list-content" :class="{'list-content-short' : showFilter}">
      <div
        v-for="data in filteredRetirement"
        :key="data"
        class="list-outer"
        :class="{
          'list-outer-green' : Number(data.retirement_year) > Number(yearNow),
          'list-outer-yellow' : Number(data.retirement_year) == Number(yearNow),
          'list-outer-red' : Number(data.retirement_year) < Number(yearNow)
        }"
        @click="null"
      >
        <p v-html="data.employee_name" class="list-inner-name" />
        <p v-html="data.ein" class="list-inner-subname" />
        <table>
          <tr>
            <td>Work Unit</td>
            <td>:</td>
            <td>{{ data.work_unit }}</td>
          </tr>
          <tr>
            <td>Effective Date</td>
            <td>:</td>
            <td>{{ formatDate(data.start_working) }}</td>
          </tr>
          <tr>
            <td>Working Period</td>
            <td>:</td>
            <td v-if="data.work_period < 2">{{ data.work_period + ' year' }}</td>
            <td v-else>{{ data.work_period + ' years' }}</td>
          </tr>
          <tr>
            <td>Retirement Year</td>
            <td>:</td>
            <td>{{ data.retirement_year }}</td>
          </tr>
          <tr>
            <td>Retirement Age</td>
            <td>:</td>
            <td>{{ data.birth_period }} years old</td>
          </tr>
        </table>
      </div>
    </div>

    <div v-if="!isLoading && !searchQuery && (dataRemaining.length == 0) && (!listRetirement)" class="list-content-none">
      <div class="list-outer-none">
        <p>No results found</p>
      </div>
    </div>

    <div v-if="!isLoading && (dataRemaining.length != 0)" class="list-content" :class="{'list-content-short' : showFilter}">
      <div
        v-for="data in filteredRemaining"
        :key="data"
        class="list-outer"
        :class="{'list-outer-purple' : listActive == data.id}"
        @click="openEmployee(data)"
      >
        <p v-html="data.employee_name" class="list-inner-name" />
        <p v-html="data.work_unit + ' | ' + data.ein" class="list-inner-subname" />
      </div>
    </div>

    <div v-if="isLoading" class="list-content">
      <div v-for="data in 3" :key="data" class="list-outer-load" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { ref, onMounted, computed, watch, reactive } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

import { AgGridVue } from 'ag-grid-vue3'
import Icon from '@/components/Icon'

import { mdiMagnify, mdiSort } from '@mdi/js'

export default {
  components: {
    AgGridVue,
    Icon
  },

  props: {
    isLoading: { type: Boolean, default: false },
    showFilter: { type: Boolean, default: false },
    dataRemaining: { type: Object, default: () => [] },
    listRetirement: { type: Object, default: () => [] },
    listActive: { type: String, default: '' }
  },

  setup(props, { emit }) {
    const userRole = localStorage.getItem('roles')
    const employeeId = localStorage.getItem('employee_id')

    const yearNow = ref('')
    const searchQuery = ref('')
    const sortOrder = ref('') // State untuk menyimpan status sort: '' (default), 'asc', 'desc'

    const getDate = () => {
      const thisDate = new Date()
      yearNow.value = thisDate.getFullYear()
    }

    const monthsEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    function formatDate(date) {
      const day = new Date(date).getDate()
      const month = new Date(date).getMonth()
      const year = new Date(date).getFullYear()

      const formattedDate = `${day} ${monthsEn[month]} ${year}`
      return formattedDate
    }

    // Fungsi untuk toggle sort
    const toggleSort = () => {
      if (sortOrder.value === '') {
        sortOrder.value = 'asc'
      } else if (sortOrder.value === 'asc') {
        sortOrder.value = 'desc'
      } else {
        sortOrder.value = ''
      }

      // console.log('sortOrder.value', sortOrder.value)
    }

    // Define search parameters for each list
    const retirementSearchParams = ['employee_name', 'ein', 'work_unit', 'retirement_year']
    const remainingSearchParams = ['employee_name', 'ein', 'work_unit']

    // Computed property for filtered retirement list
    const filteredRetirement = computed(() => {
      let data = [...props.listRetirement].filter(item => item.id != employeeId)
      if (searchQuery.value) {
        const searchText = searchQuery.value.toLowerCase()
        data = data.filter(item =>
          retirementSearchParams.some(param =>
            (item[param] ?? '').toString().toLowerCase().includes(searchText)
          )
        )
      }
      // Apply sorting
      if (sortOrder.value) {
        data.sort((a, b) => {
          const nameA = a.employee_name.toLowerCase()
          const nameB = b.employee_name.toLowerCase()
          if (sortOrder.value === 'asc') {
            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0
          } else {
            return nameA > nameB ? -1 : nameA < nameB ? 1 : 0
          }
        })
      }
      return data
    })

    // Computed property for filtered remaining leave list
    const filteredRemaining = computed(() => {
      let data = props.dataRemaining.child_list ? [...props.dataRemaining.child_list] : [...props.dataRemaining]
      if (searchQuery.value) {
        const searchText = searchQuery.value.toLowerCase()
        data = data.filter(item =>
          remainingSearchParams.some(param =>
            (item[param] ?? '').toString().toLowerCase().includes(searchText)
          )
        )
      }
      // Apply sorting
      if (sortOrder.value) {
        data.sort((a, b) => {
          const nameA = a.employee_name.toLowerCase()
          const nameB = b.employee_name.toLowerCase()
          if (sortOrder.value === 'asc') {
            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0
          } else {
            return nameA > nameB ? -1 : nameA < nameB ? 1 : 0
          }
        })
      }
      return data
    })

    onMounted(() => {
      getDate()
    })

    const openRemaining = (type, data) => {
      const prevData = {
        group: type,
        id: data,
        data: data
      }
      emit('open-remaining', prevData)
    }

    const openEmployee = (data) => {
      emit('open-employee', data)
    }

    return {
      userRole,
      yearNow,
      formatDate,
      employeeId,
      openRemaining,
      openEmployee,
      searchQuery,
      mdiMagnify,
      mdiSort,
      filteredRetirement,
      filteredRemaining,
      toggleSort,
      sortOrder
    }
  }
}
</script>

<style lang="scss" scoped>
  .remaining-leave-content {
    padding-bottom: 12px;

    .header-content {
      width: 100%;
      height: 40px;
      background-image: linear-gradient(to bottom right, indigo, purple);
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      display: flex;
      align-items: center;
      padding: 0 12px;

      p {
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        color: white;
      }
    }

    .action-content {
      width: 100%;
      height: auto;
      display: flex;
      gap: 16px;
      // align-items: center;
      // justify-content: flex-end;
      padding: 12px;

      .action-search {
        width: 90%;
        height: auto;
        display: flex;
        align-items: center;
        // justify-content: flex-end;
        background-color: purple;
        border: 2px solid indigo;
        border-radius: 8px;

        input {
          width: 100%;
          height: 40px;
          border: none;
          border-radius: 8px 0 0 8px;
        }

        .search-icon {
          margin: 0 8px;
          color: white;
        }

        p {
          font-size: 12px;
          color: white;
          font-weight: 600;
        }
      }

      .action-sort {
        width: 20%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: purple;
        border: 2px solid indigo;
        border-radius: 8px;

        .sort-icon {
          color: white;
        }
      }
    }

    .list-content {
      width: 100%;
      height: 400px;
      max-height: 400px;
      overflow-y: auto;
      padding: 12px 12px 0 12px;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .list-outer {
        width: 100%;
        height: auto;
        background-color: rgb(250, 237, 255);
        border: 2px solid rgb(239, 197, 255);
        border-radius: 12px;
        padding: 4px 12px;
        cursor: pointer;
        transition: background-color .5s, box-shadow .5s;

        .list-inner-name {
          font-size: 16px;
          line-height: 24px;
          font-weight: 500;
        }

        .list-inner-subname {
          font-size: 12px;
          line-height: 18px;
          font-weight: 500;
          margin-bottom: 8px;
        }

        table {
          tr {
            td {
              font-size: 12px;
              line-height: 20px;
              padding: 0;

              &:nth-child(1) {
                width: 100px;
              }

              &:nth-child(2) {
                width: 10px;
              }

              &:nth-child(3) {
                width: calc(100% - 100px - 10px);
                font-weight: 500;
              }
            }
          }
        }

        &:hover {
          background-color: rgb(239, 197, 255);
          // box-shadow: 0 0 10px lightgray;

          table {
            tr {
              td {
                background-color: transparent;
              }
            }
          }
        }
      }

      .list-outer-green {
        background-color: rgb(237, 255, 237);
        border: 2px solid rgb(195, 255, 195);

        &:hover {
          background-color: rgb(195, 255, 195);
        }
      }

      .list-outer-yellow {
        background-color: rgb(255, 250, 237);
        border: 2px solid rgb(255, 235, 184);

        &:hover {
          background-color: rgb(255, 235, 184);
        }
      }

      .list-outer-red {
        background-color: rgb(255, 237, 237);
        border: 2px solid rgb(255, 192, 185);

        &:hover {
          background-color: rgb(255, 192, 185);
        }
      }

      .list-outer-purple {
        background-color: rgb(239, 197, 255);
        border: 2px solid rgb(239, 197, 255);

        &:hover {
          background-color: rgb(239, 197, 255);
        }
      }

      .list-outer-load {
        width: 100%;
        height: 120px !important;
        background-color: rgb(235, 235, 235);
        border-radius: 12px;
      }
    }

    .list-content-short {
      height: calc(400px - 68px);
    }

    .list-content-none {
      width: 100%;
      height: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: gray;
    }
  }
</style>
